import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { createSelector } from 'reselect';

const selectUserPermissions = createSelector(
  state => {
    const data = state.authme.data;
    const roles = data?.roles || [];

    // جمع الصلاحيات من الأدوار + الصلاحيات المباشرة (direct permissions)
    const rolePermissions = roles.flatMap(role => role.permessions || []);
    const directPermissions = data?.permissions || [];

    return [...rolePermissions, ...directPermissions];
  },
  permissions =>
    permissions.map(perm => perm.name)

);

const hasAnyPermission = (userPermissions, requiredPermissions) => {
  return requiredPermissions.some(permission => userPermissions.includes(permission));
};

const PermissionWrapper = ({ requiredPermissions, children }) => {
  const userPermissions = useSelector(selectUserPermissions);


  if (!hasAnyPermission(userPermissions, requiredPermissions)) {

    // return <>not autherized</>;
    return <Navigate to="/not_authorized" replace />;
  }

  return children;
};

export default PermissionWrapper;
